import instalmentProcessStep from '@/constants/instalment-process-steps'

const state = {
  processSteps: null,
  currentStep: '',
}

const getters = {
  completedPercentage(state) {
    if (!state.processSteps) {
      return 0
    }

    const currentIndex =
      state.processSteps.findIndex((step) => {
        return state.currentStep === step
      }) || 0
    const totalSteps = state.processSteps.length

    return parseFloat(((currentIndex + 1) * 100) / totalSteps, 10)
  },
}

const mutations = {
  SET_PROCESS_STEPS: (state, processSteps) => {
    state.processSteps = processSteps
    state.init = false
  },
  SET_CURRENT_STEP: (state, currentStep) => {
    state.currentStep = currentStep
  },
}

const actions = {
  initProcessStep({ commit, rootGetters }) {
    const processSteps = []

    if (!rootGetters['session/isNamshiOrder']) {
      processSteps.push(instalmentProcessStep.LOGIN_ENTER_PHONE)
    }

    processSteps.push(instalmentProcessStep.LOGIN_ENTER_OTP)

    if (!rootGetters['session/order'].isVerifiedId) {
      processSteps.push(instalmentProcessStep.ELM_ENTER_ID)
      processSteps.push(instalmentProcessStep.ELM_ENTER_OTP)
    }

    processSteps.push(instalmentProcessStep.CONFIRMATION)
    processSteps.push(instalmentProcessStep.FINISH)

    commit('SET_PROCESS_STEPS', processSteps)
    commit('SET_CURRENT_STEP', instalmentProcessStep.LOGIN_ENTER_PHONE)
  },
  triggerProcessStep({ commit }, step) {
    commit('SET_CURRENT_STEP', step)
  },
}

export default { namespaced: true, state, getters, mutations, actions }
